import React from 'react';
import { SparklesIcon, ShieldIcon } from 'lucide-react';
import { excludedCriteria } from '../lib/data';
const capturedFields = ['Data Engineer principal', 'Données et analytique', 'Montréal · hybride', 'Construire, pas maintenir', 'Périmètre encore flou'];
const followUps = ["Qu'est-ce qui est le plus difficile dans ce poste ?", "À quoi verrez-vous dans 90 jours que c'était la bonne personne ?"];
export function ConversationPreview() {
  return <section className="mx-auto w-full max-w-6xl px-5 pb-2 pt-8 sm:px-8" data-id="element-39" data-mp="xibr3vfncv2c">
      <div className="rounded-card border border-line bg-white p-5" data-id="element-40" data-mp="xgh7qlk0xb0d">
        {/* Message de l'utilisateur — scénario de référence */}
        <div className="flex justify-end" data-id="element-41" data-mp="177vcb7qu110d">
          <p className="max-w-[85%] rounded-2xl rounded-br-sm bg-canvas px-4 py-2.5 text-[15px] leading-[1.55] text-ink" data-id="element-42" data-mp="176tpy74d8s3c">
            Je cherche un Data Engineer principal à Montréal pour moderniser notre plateforme de
            données. La personne doit être autonome, capable de construire et pas seulement de
            maintenir, et à l'aise avec un périmètre encore flou.
          </p>
        </div>

        {/* Réponse de Talenxia */}
        <div className="mt-4 flex gap-3" data-id="element-43" data-mp="1dz5vev5m4472">
          <div className="mt-0.5 flex h-9 w-9 flex-none items-center justify-center rounded-full bg-brand-soft text-brand" data-id="element-44" data-mp="1e08jkvbjvsja">
            <SparklesIcon className="h-[18px] w-[18px]" strokeWidth={1.75} data-id="element-45" data-mp="191xbap0wlq36" />
          </div>
          <div className="min-w-0 flex-1" data-id="element-46" data-mp="26nbivpo1w7al">
            <p className="text-[13px] font-500 text-muted" data-id="element-47" data-mp="21p06b76dfioo">Talenxia</p>
            <div className="mt-2 space-y-2" data-id="element-48" data-mp="21qusspxajiuv">
              {followUps.map(q => <p key={q} className="rounded-xl border border-line bg-canvas px-4 py-2.5 text-[15px] leading-[1.55] text-ink" data-id="element-49" data-mp="1ww71yketecd4">
                  {q}
                </p>)}
            </div>

            <div className="mt-3 flex flex-wrap items-center gap-2" data-id="element-50" data-mp="2kn46hc4a67ec">
              <span className="text-[12px] text-muted" data-id="element-51" data-mp="2klt2pcau4zn8">Déjà capté&nbsp;:</span>
              {capturedFields.map(field => <span key={field} className="rounded-full border border-line bg-canvas px-2.5 py-1 text-[12px] font-500 text-ink" data-id="element-52" data-mp="ms73zmez1jlz">
                  {field}
                </span>)}
            </div>

            {/* Critères écartés. Guide V2 : une interdiction s'écrit en
                texte ink sur fond brand-soft — pas de rouge d'erreur distinct. */}
            <div className="mt-4 rounded-card bg-brand-soft px-4 py-3" data-id="element-53" data-mp="41z3lc2np79h">
              <p className="flex items-center gap-1.5 text-[10px] font-600 tracking-[0.09em] text-ink" data-id="element-54" data-mp="3m7c10r1542ir">
                <ShieldIcon className="h-3.5 w-3.5 text-brand" strokeWidth={2} data-id="element-55" data-mp="3r53uvqlchypl" />
                CRITÈRES QUE JE N'UTILISERAI PAS
              </p>
              <ul className="mt-2 space-y-1" data-id="element-56" data-mp="1kdct8fn883at">
                {excludedCriteria.map(item => <li key={item.label} className="text-[13px] leading-[1.4] text-ink" data-id="element-57" data-mp="1pcfz22b16dju">
                    <span className="font-500" data-id="element-58" data-mp="1zipa9etoasgc">{item.label}</span>
                    <span className="text-muted" data-id="element-59" data-mp="1uk5opfizrioi"> — {item.reason}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}